<app-bills [programme_category]="'private_programme'"></app-bills>
